module.exports = __webpack_public_path__ + "img/e_3_27_g.9dcc7973.png";